import script from "./RoomCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomCard.vue?vue&type=script&setup=true&lang=js"

import "./RoomCard.vue?vue&type=style&index=0&id=2d956735&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d956735"]])

export default __exports__